import { useAuthorizedQuery } from '@/hooks/useAuthorizedQuery';
import { apiClient } from '@/lib/api-client';

/**
 * Whether the signed-in user is a platform admin (founder-only tooling),
 * resolved from the backend's PLATFORM_ADMIN_EMAILS allowlist via
 * GET /admin/access-check — never from the user's org role. Every org owner
 * is "OWNER" of their own organization, so an org-role check here would
 * grant every customer access to founder-only admin pages.
 */
export function usePlatformAdmin() {
  const { data, isLoading } = useAuthorizedQuery({
    queryKey: ['platform-admin-access-check'],
    queryFn: (token: string) =>
      apiClient.get<{ isPlatformAdmin: true }>('/api/v1/admin/access-check', token),
    retry: false,
    staleTime: 5 * 60 * 1000,
    throwOnError: false,
  });

  return { isPlatformAdmin: data?.isPlatformAdmin === true, isLoading };
}
